import React from 'react';

const AnalysisSkeleton = () => {
  return (
    <div className="animate-pulse">
      {/* Resumen de Puntuación */}
      <div className="mb-8 p-6 bg-gray-100 rounded-xl">
        <div className="flex items-center gap-4 mb-4">
          <div className="relative">
            <div className="w-24 h-24 rounded-full bg-gray-300"></div>
            <div className="absolute -bottom-2 -right-2 w-10 h-6 bg-gray-400 rounded-full"></div>
          </div>
          <div className="flex-1">
            <div className="h-6 bg-gray-300 rounded w-1/2 mb-2"></div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
              <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
              <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
              <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
              <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
            </div>
            <div className="h-4 bg-gray-300 rounded w-3/4"></div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
          <div className="bg-white p-4 rounded-lg border border-gray-200">
            <div className="h-5 bg-gray-300 rounded w-1/3 mb-3"></div>
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-full"></div>
              <div className="h-4 bg-gray-200 rounded w-5/6"></div>
              <div className="h-4 bg-gray-200 rounded w-4/6"></div>
            </div>
          </div>
          <div className="bg-white p-4 rounded-lg border border-gray-200">
            <div className="h-5 bg-gray-300 rounded w-1/3 mb-3"></div>
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-full"></div>
              <div className="h-4 bg-gray-200 rounded w-5/6"></div>
              <div className="h-4 bg-gray-200 rounded w-4/6"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Grid de mejoras */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        {[1, 2, 3, 4].map((index) => (
          <div key={index} className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6">
            <div className="absolute top-4 right-4 w-2 h-2 rounded-full bg-gray-300"></div>
            <div className="flex items-start gap-4">
              <div className="p-3 bg-gray-100 rounded-lg">
                <div className="w-6 h-6 bg-gray-300 rounded"></div>
              </div>
              <div className="flex-1">
                <div className="h-5 bg-gray-300 rounded w-2/3 mb-2"></div>
                <div className="h-4 bg-gray-200 rounded w-5/6 mb-3"></div>
                <div className="space-y-2">
                  <div className="h-3 bg-gray-200 rounded w-full"></div>
                  <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                  <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnalysisSkeleton; 